import React, {useContext, useState} from 'react';
import GeneralContext from "../context/GeneralProvider";
import {toast} from "react-toastify";

function Login() {
    const {setUser} = useContext(GeneralContext)
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const login = (e) => {
        e.preventDefault();
        if(username === "audiotime"){
            if(password === "fordpuma#"){
                setUser("audiotime");
                localStorage.setItem("clerkUser", "audiotime");
            }else{
                toast.error("Şifren yanlış!");
            }
        }else{
            toast.error("Kullanıcı adın yanlış!");
        }
    }

    return (
        <form onSubmit={login}>
            <h1>Login</h1>
            <div>
                <input
                    type="text"
                    value={username}
                    autoComplete="off"
                    name="username"
                    placeholder="Username"
                    onChange={e=>setUsername(e.target.value)}
                />
            </div>
            <div>
                <input
                    type="password"
                    value={password}
                    name="password"
                    autoComplete="off"
                    placeholder="Password"
                    onChange={e=>setPassword(e.target.value)}
                />
            </div>
            <div><button type="submit" id="login">Giriş</button></div>
        </form>
    );
}

export default Login;